import { isNonEmptyString } from '@/api/queries/utils';
import { FILTER_CONFIG } from '@/models/filter/filterConfig';
import type { SelectItem } from '@/types/ui/selectItem';
import { isFilterType } from '@/utils/filter/isFilterType';

/**
 * Local filter modules store multi-selects as string arrays and single-selects
 * (e.g. Insight assignment) as a plain string, where `''` means no selection.
 * Normalizes both shapes to the list of selected values.
 */
export const getLocalFilterValues = (filterValue: unknown): string[] => {
  if (Array.isArray(filterValue)) {
    return filterValue.filter((selectedValue): selectedValue is string => typeof selectedValue === 'string');
  }
  return isNonEmptyString(filterValue) ? [filterValue] : [];
};

/**
 * Resolves the label of a value picked from a filter's static options
 * (e.g. Insight assignment `hcp` → its option label). Falls back to the raw value.
 */
export const getLocalFilterValueLabel = (
  filterKey: string,
  value: string,
  translate: (key: string) => string,
): string => {
  if (!isFilterType(filterKey)) return value;
  const config = FILTER_CONFIG[filterKey];
  const staticOptions: ReadonlyArray<SelectItem<unknown>> =
    'options' in config && Array.isArray(config.options) ? config.options : [];
  const option = staticOptions.find(staticOption => staticOption.value === value);
  return typeof option?.label === 'string' ? translate(option.label) : value;
};
